export const getCanModifySchema = (object?: ObjectDto): boolean => {
    return !object?.is_schema_read_only
}
